module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BMH-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI-3"
  }, [_vm._v("The authors would like to acknowledge their debts to Snorri Sturluson (1179–1241), the author of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Prose Edda;")]), _vm._v(" the Viking Answer Lady and her fascinating and tremendously helpful website, "), _c('a', {
    attrs: {
      "href": "http://www.vikinganswerlady.com",
      "target": "_blank"
    }
  }, [_vm._v("www.vikinganswerlady.com")]), _vm._v("; Dr. Robert J. Hasenfratz (for teaching Bear Anglo-Saxon all these years ago); Mitchell and Robinson’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Guide to Old English;")]), _vm._v(" Jennifer Jackson, agent beyond compare; and Beth Meacham, for being the extraordinary editor that she is. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466fc50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0